import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const saveProject = graphql(
  gql`
    mutation createProDesignProject(
      $proDesignProject: ProDesignProjectInput!,
      $admProject: Boolean,
      $userId: String
    ) {
      createProDesignProject(
        proDesignProject: $proDesignProject,
        admProject: $admProject,
        userId: $userId
      ) {
        message
        shortId
      }
    }
  `,
  {
    name: 'createProject'
  }
)

export const addProductsProjectMutation = graphql(
  gql`
    mutation addProductsProject(
      $projectId: String!, $products: [String], $admUser: String!, 
      $predyeds: [String], $vinyls: [String], $designVendor: Boolean
    ) {
      addProductsProject(
        projectId: $projectId, products: $products, admUser: $admUser, 
        predyeds: $predyeds, vinyls: $vinyls, designVendor: $designVendor
      ) {
        message
      }
    }
  `,
  {
    name: 'addProductsProject'
  }
)

export const renameFile = graphql(
  gql`
    mutation renameFileName($id: Int, $value: String) {
      renameFileName(id: $id, value: $value) {
        message
      }
    }
  `,
  {
    name: 'renameFileName'
  }
)

export const GetColorsQuery = gql`
  query GetColors {
    colorsResult: getColors {
      colors
    }
  }
`

export const GetColorPalettes = gql`
  query getProDesignPalettes {
    rows: getProDesignPalettes {
      id
      name
      primary: primary_color
      accent1: accent_1
      accent2: accent_2
      accent3: accent_3
      fromAdmin: from_admin
    }
  }
`

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        id
        firstName: first_name
        lastName: last_name
        email
        phone
        showProDesign: show_pro_design
      }
    }
  }
`

export const getProDesignProjects = gql`
  query getProDesignProjects(
      $limit: Int,
      $offset: Int,
      $order: String,
      $orderAs: String
    ) {
      projectsResult: getProDesignProjects(
        limit: $limit,
        offset: $offset,
        order: $order,
        orderAs: $orderAs
      ) {
      fullCount
      projects {
        id
        shortId: short_id
        name
        status
        shared
        designs(showArchivedItems: false, fromCustomer: true) {
          shortId: short_id
        }
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/IntakeForm/data.ts